export function tidyText(text){
    text=stripP(text)
    text=fixBR(text)
    return text
}
export function tidyObj(obj) {
    let newObj=obj
    let keys=Object.keys(obj)
    let objItem
   
    for(var k in keys){
        objItem=stripP(obj[keys[k]])
        objItem=stripL(objItem)
       
        newObj[keys[k]]=objItem
    }
    for(var l in newObj.locations){
        newObj.locations[l]=splitID( newObj.locations[l])  
    }
    
    return newObj
}
export function tidyMap(obj){
    let newObj=tidyObj(obj)
   
    let temp
    if(newObj.corners){
        temp=newObj.corners.split(",")
        newObj.tl=getLatLon(temp[0])
        newObj.br=getLatLon(temp[1])
        newObj.width= distanceGPS(newObj.tl.lat,newObj.tl.lon,newObj.tl.lat,newObj.br.lon)
        newObj.height= distanceGPS(newObj.tl.lat,newObj.tl.lon,newObj.br.lat,newObj.tl.lon)
        delete newObj.corners
    }
    return newObj

}
export function tidyLoc(obj){
    let newObj=tidyObj(obj)
    let temp
    if(newObj.gps){
        temp=stripU(newObj.gps)
        temp=temp.split(",")
        newObj.lat=parseFloat(temp[0],10)
        newObj.lon=parseFloat(temp[1],10)
        delete newObj.gps
    }
    if(newObj.radius){
        newObj.radius=parseInt(newObj.radius,10)
    }
    return newObj

}

export function textToObj(text) {
    let newObj={}
    var wreckKeys=Object.keys(text)
    var wreck
    var docKeys
    var docText
    for(var k in wreckKeys){
        wreck=text[wreckKeys[k]]
        newObj[wreckKeys[k]]={}
        docKeys=Object.keys(wreck)
        for(var d in docKeys){ 
           
            docText=stripP(wreck[docKeys[d]])
          
            docText=stripL(docText)
           
            newObj[wreckKeys[k]][docKeys[d]]=docText
        }
    }
   
    
   
    return newObj;
}
function getLatLon(val){
    let result={}
    val=val.split(":")
    if(!isNaN(val[1].split(" ")[0]) && !isNaN(val[1].split(" ")[0])){
        result.lat=parseFloat(val[1].split(" ")[0],10)
        result.lon=parseFloat(val[2].split(" ")[0],10)
        return result
    }
    return {lat:"?",lon:"?"}

}
function splitID(val){
    if(typeof val=="string"){
        let result={}
        val=val.split(" ")
        result.id=val[0]
        if(val.length>1){
            val.shift()
            val=val.join(" ")
            result.name=val
        }
        return result
    }
    return val

    
}

function stripU(val){
    if(typeof val=="string"){
    val=val.split("<u>").join("").split("</u>").join("")
    val=val.split("<U>").join("").split("</U>").join("")
    }
    return val
}
function stripP(val){
   
    if(typeof val=="string"){
        val=val.split("<p>").join("").split("</p>").join("")
        val=val.split("<P>").join("").split("</P>").join("")
    }
    return val
}
function fixBR(val){
    if(typeof val=="string"){
    val=val.split("&lt;").join("<")
    val=val.split("&gt;").join(">")
    }
    return val
}
function stripL(val){
    if(typeof val=="string"){
        if(val.indexOf("</li>")>=0){
            val=val.split("<ul>").join("").split("</ul>")
            val=val[0].split("<li>").join("").split("</li>")
            val.pop()
            
            
        }
    }
    return val
} 
function distanceGPS(lat1,lon1,lat2,lon2){
    const R = 6371e3; // metres
    const φ1 = lat1 * Math.PI/180; // φ, λ in radians
    const φ2 = lat2 * Math.PI/180;
    const Δφ = (lat2-lat1) * Math.PI/180;
    const Δλ = (lon2-lon1) * Math.PI/180;

    const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ/2) * Math.sin(Δλ/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    const d = R * c; // in metres
    return parseInt(d)
}
           
